export enum ProductTypeEnum {
	VUN = 'VUN',
}
